import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const WxTokenKey = 'Wx-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getWxToken() {
  return Cookies.get(WxTokenKey)
}

export function setWxToken(token) {
  return Cookies.set(WxTokenKey, token)
}

export function removeWxToken() {
  return Cookies.remove(WxTokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js